module.exports = __webpack_public_path__ + "img/3.1b70f393.jpg";